import { FilterType } from "../../shared/DTO/filterType";
import { BaseModel } from "../../base/models/base-model.model";
import { ProductState } from "../../shared/DTO/productState";

export class OrdersResearchFilterModel extends BaseModel {
  private _accountCode?: string;
  private _activationDataFrom?: string;
  private _activationDataTo?: string;
  private _externalCommonOrdersId?: string;
  private _commonOrdersId?: string;
  private _applicantTaxCode?: string;
  private _companyName?: string;
  private _customerCode?: string;
  private _filterType?: FilterType;
  private _holderId?: string;
  private _holderTaxCode?: string;
  private _insertDate?: string;
  private _mailboxName?: string;
  private _mailboxNameLike?: string;
  private _name?: string;
  private _nickname?: string;
  private _orderId?: number;
  private _productTypes?: string[];
  private _resellerOrderId?: string;
  private _surname?: string;
  private _surnameAndName?: string;
  private _suspendedOrders?: boolean;
  private _taxCode?: string;
  private _unit?: string;
  private _userId?: string;
  private _state?: ProductState;
  private _emailAddress?: string;
  private _mobileNumber?: string;
  private _insertOperatorId?: string;
  private _iut?: string;
  private _deviceId?: string;

  // tslint:disable-next-line:max-line-length
  constructor(
    accountCode?: string,
    activationDataFrom?: string,
    activationDataTo?: string,
    externalCommonOrdersId?: string,
    commonOrdersId?: string,
    applicantTaxCode?: string,
    companyName?: string,
    customerCode?: string,
    filterType?: FilterType,
    holderId?: string,
    holderTaxCode?: string,
    insertDate?: string,
    mailboxName?: string,
    mailboxNameLike?: string,
    name?: string,
    nickname?: string,
    orderId?: number,
    productTypes?: string[],
    resellerOrderId?: string,
    surname?: string,
    surnameAndName?: string,
    suspendedOrders?: boolean,
    taxCode?: string,
    unit?: string,
    userId?: string,
    state?: ProductState,
    emailAdddress?: string,
    mobileNumber?: string,
    insertOperatorId?: string,
    iut?: string,
    deviceId?: string
  ) {
    super();
    this._accountCode = accountCode;
    this._activationDataFrom = activationDataFrom;
    this._activationDataTo = activationDataTo;
    this._externalCommonOrdersId = externalCommonOrdersId;
    this._commonOrdersId = commonOrdersId;
    this._applicantTaxCode = applicantTaxCode;
    this._companyName = companyName;
    this._customerCode = customerCode;
    this._filterType = filterType;
    this._holderId = holderId;
    this._holderTaxCode = holderTaxCode;
    this._insertDate = insertDate;
    this._mailboxName = mailboxName;
    this._mailboxNameLike = mailboxNameLike;
    this._name = name;
    this._nickname = nickname;
    this._orderId = orderId;
    this._productTypes = productTypes;
    this._resellerOrderId = resellerOrderId;
    this._surname = surname;
    this._surnameAndName = surnameAndName;
    this._suspendedOrders = suspendedOrders;
    this._taxCode = taxCode;
    this._unit = unit;
    this._userId = userId;
    this._state = state;
    this._emailAddress = emailAdddress;
    this._mobileNumber = mobileNumber;
    this._insertOperatorId = insertOperatorId;
    this._iut = iut;
    this._deviceId = deviceId;
  }

  get state(): ProductState {
    return this._state;
  }

  set state(value: ProductState) {
    this._state = value;
  }

  get accountCode(): string {
    return this._accountCode;
  }

  set accountCode(value: string) {
    this._accountCode = value;
  }

  get activationDataFrom(): string {
    return this._activationDataFrom;
  }

  set activationDataFrom(value: string) {
    this._activationDataFrom = value;
  }

  get activationDataTo(): string {
    return this._activationDataTo;
  }

  set activationDataTo(value: string) {
    this._activationDataTo = value;
  }

  get externalCommonOrdersId(): string {
    return this._externalCommonOrdersId;
  }

  set externalCommonOrdersId(value: string) {
    this._externalCommonOrdersId = value;
  }

  get commonOrdersId(): string {
    return this._commonOrdersId;
  }

  set commonOrdersId(value: string) {
    this._commonOrdersId = value;
  }

  get applicantTaxCode(): string {
    return this._applicantTaxCode;
  }

  set applicantTaxCode(value: string) {
    this._applicantTaxCode = value;
  }

  get companyName(): string {
    return this._companyName;
  }

  set companyName(value: string) {
    this._companyName = value;
  }

  get customerCode(): string {
    return this._customerCode;
  }

  set customerCode(value: string) {
    this._customerCode = value;
  }

  get filterType(): FilterType {
    return this._filterType;
  }

  set filterType(value: FilterType) {
    this._filterType = value;
  }

  get holderId(): string {
    return this._holderId;
  }

  set holderId(value: string) {
    this._holderId = value;
  }

  get holderTaxCode(): string {
    return this._holderTaxCode;
  }

  set holderTaxCode(value: string) {
    this._holderTaxCode = value;
  }

  get insertDate(): string {
    return this._insertDate;
  }

  set insertDate(value: string) {
    this._insertDate = value;
  }

  get mailboxName(): string {
    return this._mailboxName;
  }

  set mailboxName(value: string) {
    this._mailboxName = value;
  }

  get mailboxNameLike(): string {
    return this._mailboxNameLike;
  }

  set mailboxNameLike(value: string) {
    this._mailboxNameLike = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get nickname(): string {
    return this._nickname;
  }

  set nickname(value: string) {
    this._nickname = value;
  }

  get orderId(): number {
    return this._orderId;
  }

  set orderId(value: number) {
    this._orderId = value;
  }

  get productTypes(): string[] {
    return this._productTypes;
  }

  set productTypes(value: string[]) {
    this._productTypes = value;
  }

  get resellerOrderId(): string {
    return this._resellerOrderId;
  }

  set resellerOrderId(value: string) {
    this._resellerOrderId = value;
  }

  get surname(): string {
    return this._surname;
  }

  set surname(value: string) {
    this._surname = value;
  }

  get surnameAndName(): string {
    return this._surnameAndName;
  }

  set surnameAndName(value: string) {
    this._surnameAndName = value;
  }

  get suspendedOrders(): boolean {
    return this._suspendedOrders;
  }

  set suspendedOrders(value: boolean) {
    this._suspendedOrders = value;
  }

  get taxCode(): string {
    return this._taxCode;
  }

  set taxCode(value: string) {
    this._taxCode = value;
  }

  get unit(): string {
    return this._unit;
  }

  set unit(value: string) {
    this._unit = value;
  }

  get userId(): string {
    return this._userId;
  }

  set userId(value: string) {
    this._userId = value;
  }

  get emailAddress(): string {
    return this._emailAddress;
  }

  set emailAddress(value: string) {
    this._emailAddress = value;
  }

  get mobileNumber(): string {
    return this._mobileNumber;
  }

  set mobileNumber(value: string) {
    this._mobileNumber = value;
  }

  get insertOperatorId(): string {
    return this._insertOperatorId;
  }

  set insertOperatorId(value: string) {
    this._insertOperatorId = value;
  }

  get iut(): string {
    return this._iut;
  }

  set iut(value: string) {
    this._iut = value;
  }

  get deviceId(): string {
    return this._deviceId;
  }

  set deviceId(value: string) {
    this._deviceId = value;
  }
}
